import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IAlertPopupModel } from '../../models/popup.model';
import { BasePopupComponent } from '../base-popup/base-popup.component';

@Component({
    selector: 'app-success-popup',
    standalone: false,
    templateUrl: './success-popup.component.html',
    styleUrl: './success-popup.component.scss',
})
export class SuccessPopupComponent extends BasePopupComponent {
    protected confirmButtonLabel: string = 'Okay';
    protected iconPath?: string = '';
    protected message: string = '';
    protected title: string = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: IAlertPopupModel,
        protected override dialogRef: MatDialogRef<SuccessPopupComponent>,
    ) {
        super(data, dialogRef);
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.data) {
            this.title = this.data.title || this.title;
            this.message = this.data.message || this.message;
            this.iconPath = this.data.iconPath || this.iconPath;
            this.confirmButtonLabel = this.data.confirmButtonLabel || this.confirmButtonLabel;
        }
    }
}
